var exports = {
  "p": "list__1mC184",
};

module.exports = exports;
